import { Typography } from "@mui/material";
import type { FunctionComponent } from "react";

export interface NoDataProps {
  label?: string;
}

export const NoData: FunctionComponent<NoDataProps> = ({ label = "-" }) => {
  return (
    <Typography component="span" fontSize="1em" color="text.secondary">
      {label}
    </Typography>
  );
};
